import { boolean, object, string, number } from 'yup';

export const ASSIGNMENT_SCHEMA = object({
	unit: object({
		course_id: number(),
		type_id: number(),
		name: string(),
		order: number(),
		active: boolean(),
	}),
	assignment: object({
		question: string().required(),
		question_type: string(),
		overall_score: number()
			.typeError('Capacity Must be a number')
			.moreThan(0, 'Capacity must be bigger than zero')
			.required(),
		// Blank = no deadline (the student portal and backend treat null/0 as
		// "always submittable").
		duration: number()
			.transform((value, original) => (original === '' || original === null || Number.isNaN(value) ? null : value))
			.nullable()
			.typeError('Duration must be a number')
			.moreThan(0, 'Duration must be bigger than zero')
			.notRequired(),
		answer_schema: string().oneOf(['*', 'text', 'attachment']).default('*'),
		show_status: boolean().default(false),
		extension: string().default('pdf'),
	}),
});
